import React, { useState } from "react";

import { IconButton, InputAdornment, TextField } from "@mui/material";
import { useController } from "react-hook-form";

import { ReactComponent as Visibility } from "../../../Assets/Images/Visibility.svg";
import { ReactComponent as VisibilityOff } from "../../../Assets/Images/VisibilityOff.svg";
import { FormItemsWrap } from "../../molecules/Wrap/Wrap";
import Label from "./Label";

export const PasswordInput = ({
  control,
  label,
  name,
  width,
  size,
  disabled,
  showLabel,
  fullWidth,
  required,
  isInherit,
  hideValidBorderColor,
  onClick,
}) => {
  const { field, fieldState } = useController({
    control: control,
    name: name,
  });
  const [showPassword, setShowPassword] = useState(false);
  const handleTogglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const outlinedSelectors = [
    "& .MuiOutlinedInput-notchedOutline",
    "&:hover .MuiOutlinedInput-notchedOutline",
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline",
  ];
  return (
    <FormItemsWrap>
      <Label label={label} required={required} />

      <TextField
        sx={{
          "& label.Mui-focused": {
            color: "red",
          },
          [outlinedSelectors.join(",")]: {
            border:
              !hideValidBorderColor &&
              !fieldState?.invalid &&
              field.value &&
              "1px solid var(--SystemBlue-Light-5-Primary, #007AFF)",
          },
        }}
        style={{}}
        onClick={onClick}
        type={showPassword ? "text" : "password"}
        fullWidth={fullWidth}
        disabled={disabled}
        variant="outlined"
        inputProps={{
          style: {
            width: width,
          },
        }}
        error={fieldState?.invalid}
        helperText={fieldState?.error?.message}
        value={field.value}
        label={showLabel ? label : undefined}
        {...field}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={handleTogglePasswordVisibility}>
                {showPassword ? (
                  <Visibility
                    role="img"
                    type="img"
                    aria-label="Visibility Icon"
                  />
                ) : (
                  <VisibilityOff
                    role="img"
                    type="img"
                    aria-label="VisibilityOff Icon"
                  />
                )}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    </FormItemsWrap>
  );
};
